import React from 'react'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { scroller } from 'react-scroll'
import { GatsbyLinkProps, Link as GatsbyLink } from 'gatsby'
import { useContext } from '~/hooks'

export type Props = Omit<
  Omit<GatsbyLinkProps<Record<string, unknown>>, 'ref'>,
  'to'
> & {
  external?: boolean
  href: string
}

const Link = ({ external, href, onClick, ...props }: Props) => {
  const scrollOffset = useBreakpoint().sm ? -70 : 0
  const { openWorkModal } = useContext()

  if (href === '/acompanhe-a-obra/')
    return (
      <a
        href={href}
        onClick={(e) => {
          e.preventDefault()
          openWorkModal()
          onClick?.(e)
        }}
        {...props}
      ></a>
    )

  if (external)
    return (
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        onClick={onClick}
        {...props}
      ></a>
    )
  return (
    <GatsbyLink
      to={href}
      onClick={(e) => {
        if (href.includes('#')) {
          e.preventDefault()
          scroller.scrollTo(href.split('#')[1], {
            smooth: true,
            duration: 500,
            offset: scrollOffset,
          })
        }
        onClick?.(e)
      }}
      {...props}
    ></GatsbyLink>
  )
}

export default Link
